'use client';
import React, { FC } from 'react';
import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';
import { Conditional } from '@cat-ecom/pcc-components';
import PartsCheckPrice from '../../parts-check-price';
import { revalidateCart } from 'services/parts-diagram/actions';
import useURLParams from 'hooks/useURLParams';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import ContactDealerTooltip from 'components/parts-overview/contact-dealer-tooltip';
import { LineItem } from 'types/parts-diagram';
import { getHandleclickViewButton } from 'utils/parts-diagram';

export interface TableButtonProps {
  index: number;
  lineItem: LineItem;
  quantity: string;
  disableRow: boolean;
  handlePartView: () => void;
  shouldHideBtn?: boolean;
}

const TableButtons: FC<TableButtonProps> = ({
  index,
  handlePartView,
  lineItem,
  quantity,
  disableRow,
  shouldHideBtn
}) => {
  const t = useTranslations();
  const {
    isCatCorp,
    handleAddToCart,
    analyticsCommonInfo: { dealerData, model, currency } = {}
  } = usePartDiagram();

  const displayCheckprice = isCatCorp && index === 0;
  const {
    ieSystemControlNumber,
    disambiguation,
    priceAndAvailabilityData = { enableAddToCart: false }
  } = lineItem;
  const getHandleSelectedPart = usePartDiagram();
  const getparams = useURLParams();

  const handleClick = async (partNumber) => {
    getHandleclickViewButton(partNumber, getHandleSelectedPart, getparams);
  };

  const analyticsInformation = {
    currency,
    model,
    dealerData
  };

  return (
    <>
      {displayCheckprice && <PartsCheckPrice />}
      {!ieSystemControlNumber && disambiguation && !shouldHideBtn && (
        <CatButton size="sm" onClick={() => handleClick(lineItem.partNumber)}>
          {t('VIEW')}
        </CatButton>
      )}

      {!disambiguation && (
        <Conditional
          test={!!ieSystemControlNumber}
          fallback={
            !isCatCorp &&
            (priceAndAvailabilityData?.enableAddToCart ? (
              <CatButton
                size="sm"
                variant="primary"
                disabled={
                  getHandleSelectedPart.disableAddToCart ||
                  disableRow ||
                  quantity === '0' ||
                  quantity === undefined
                }
                onClick={() => {
                  handleAddToCart(lineItem, quantity, analyticsInformation);
                  revalidateCart();
                }}
              >
                {t('ADD_TO_CART')}
              </CatButton>
            ) : (
              <ContactDealerTooltip />
            ))
          }
        >
          {!shouldHideBtn && (
            <CatButton size="sm" onClick={() => handlePartView()}>
              {t('VIEW')}
            </CatButton>
          )}
        </Conditional>
      )}
    </>
  );
};

export default TableButtons;
